import { render } from "./MineSweep.vue?vue&type=template&id=7a0b40d7"
import script from "./MineSweep.vue?vue&type=script&lang=js"
export * from "./MineSweep.vue?vue&type=script&lang=js"

import "./MineSweep.vue?vue&type=style&index=0&id=7a0b40d7&lang=css"

import exportComponent from "/builds/games/game.xiaofei.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__